// NETWORK CONFIGURATION
// Change this to switch between testnet and mainnet
const USE_MAINNET = true; // Set to true for mainnet, false for testnet

const NETWORKS = {
  mainnet: {
    chainId: '0x38', // 56 in hex
    chainIdDecimal: 56,
    chainName: 'BNB Smart Chain',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    },
    rpcUrls: ['https://bsc-dataseed.binance.org/'],
    blockExplorerUrls: ['https://bscscan.com/'],
    contractAddress: '0xDc49c817EaB09375e8901E02a38aD6985eB5e3a3', // Replace with mainnet contract
    tokenAddress: '0x55d398326f99059ff775485246999027b3197955' // Replace with mainnet token
  },
  testnet: {
    chainId: '0x61', // 97 in hex
    chainIdDecimal: 97,
    chainName: 'BNB Smart Chain Testnet',
    nativeCurrency: {
      name: 'tBNB',
      symbol: 'tBNB',
      decimals: 18
    },
    rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
    blockExplorerUrls: ['https://testnet.bscscan.com/'],
    contractAddress: '0x0647BEe966a65E6078c284d615a88416De0B7120',
    tokenAddress: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC'
  }
};

export const NETWORK = USE_MAINNET ? NETWORKS.mainnet : NETWORKS.testnet;
export const EXPLORER_URL = NETWORK.blockExplorerUrls[0];